import styled from 'styled-components'

export const PatientGoalContainer = styled.div`
  width: 100%;
`

export const RadioButtonOptions = styled.div`
  margin-top: 12px;

  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
`
